import React from 'react'
import { Row, Col, SVGIcon } from 'components/qstrap'

import ShareSvg from 'components/atoms/SVGIcons/Share'
import Button from 'components/atoms/Button'
import Container from 'components/atoms/Container'
import SectionContainer from 'components/atoms/SectionContainer'
import Typography from 'components/atoms/Typography'

import isNavigatorAvailable from 'utils/isNavigatorAvailable'
import config from 'config'

const { assets_url: assetsUrl } = config
const aptReportAssetsPath = `${assetsUrl}/assets/img/aptitude/report`

const AptitudeShare = () => {
  const showMedia = () => {
    if (isNavigatorAvailable() && navigator.share !== undefined) {
      navigator.share({
        text: 'Hai, aku sudah menyelesaikan Tes Minat Bakat di Quipper Campus.' +
        '\n' +
        'Dan sudah menemukan jurusan yang cocok untuk ku loh!' +
        '\n\n' +
        'https://campus.quipper.com/aptitude_test?utm_campaign=ATShare' +
        '\n\n' +
        'Yuk ikutan juga Tes Minat Bakat di Quipper Campus! GRATIS loh!',
        url: 'https://campus.quipper.com/aptitude_test?utm_campaign=ATShare',
      })
    }
  }

  return (
    <div className="aptitude-share">
      <SectionContainer
        paddingBottom={120}
        paddingTop={120}
        backgroundColor="transparent"
      >
        <Container>
          <Row>
            <Col md="7">
              <Typography component="p" variant="subheading" className="m-b-lg">
                Hasil tes ini dapat kamu jadikan panduan dalam membuat keputusan studi dan jalur kariermu. Pelajari hasilnya secara menyeluruh, dan lakukan eksplorasi lebih dalam pada karier dan jurusan pilihanmu melalui website <a href="/" target="_blank"><b>campus.quipper.com.</b></a>
              </Typography>
              <Typography component="p" variant="subheading" className="m-b-lg">Semoga kamu menemukan pilihan terbaik untuk masa depanmu!</Typography>
            </Col>
          </Row>
          {
            (isNavigatorAvailable() && navigator.share !== undefined) &&
            <Button className="aptitude-share__btn" onClick={showMedia}>
              <ShareSvg fill="#fff" className="icon icon-sm icon-align-middle m-r-md"/>
              Bagikan
            </Button>
          }
          <Button variant="solid" href="/" className="aptitude-share__btn">
            <SVGIcon name="nav-home" size="sm" className="icon-align-middle m-r-md"/>
            Kembali ke Beranda
          </Button>
        </Container>
      </SectionContainer>
      <style jsx>
        {`
          .aptitude-share {
            background-image: url(${aptReportAssetsPath}/cloud.png), url(${aptReportAssetsPath}/background.png), url(${aptReportAssetsPath}/rectangle-blue-2.png);
            background-repeat: no-repeat;
            background-position: 10% 20%, bottom right, top center;
            background-size: auto, auto, contain;
            @media screen and (max-width: 767px) {
              background-size: auto, contain, cover;
              padding-bottom: 100px;
            }
            :global(&__btn) {
              @media screen and (max-width: 767px) {
                display: block;
                margin-bottom: 15px;
              }
            }
          }
        `}
      </style>
    </div>
  )
}

export default AptitudeShare
